import { Box } from '@mui/material';
import Image from 'next/image';
import { LOGO_IMAGE_SIZE, LOGO_MAX_HEIGHT_MOBILE, LOGO_MAX_WIDTH_DESKTOP, LOGO_MAX_WIDTH_MOBILE } from './constants';

type Props = {
  source?: string;
  alt?: string;
  imageMaxWidth?: string;
};

export const ProductLogo = ({ source, alt, imageMaxWidth = LOGO_MAX_WIDTH_DESKTOP }: Props) => {
  if (!source) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'min-content',
        maxHeight: { xs: LOGO_MAX_HEIGHT_MOBILE, md: 'none' },
        maxWidth: { xs: LOGO_MAX_WIDTH_MOBILE, md: imageMaxWidth },
        '& img': {
          maxHeight: { xs: LOGO_MAX_HEIGHT_MOBILE, md: 'none' },
        },
      }}
    >
      <Image
        src={source}
        alt={alt ?? 'product logo'}
        width={LOGO_IMAGE_SIZE}
        height={LOGO_IMAGE_SIZE}
        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
      />
    </Box>
  );
};
